
import { Component, Vue, Prop } from "vue-property-decorator"
import api from "@/services/api"

	@Component({})
export default class PictureSelect extends Vue {
		public $refs!: {
			fileInput: HTMLInputElement;
		};

		/**
		 * @summary The current picture, either a file or a URL.
		 */
		@Prop({ type: [String, File], default: null }) private readonly value!: File | string | null;

		private readonly permittedFileTypes: string[] = ["image/png", "image/jpeg"];
		private readonly permittedFileExtensions: string[] = ["png", "jpg", "jpeg"];

		private dragging: boolean = false;

		/**
		 * @summary Gets the URL of the picture to display for the user. Returns either the URL to the new picture
		 * they have selected, or the users existing profile picture.
		 */
		private get displayPictureUrl (): string | null {
			if (!this.value) {
				return null
			}

			if (typeof (this.value) === "string") {
				return this.value
			} else {
				return URL.createObjectURL(this.value)
			}
		}

		/**
		 * @summary Attempts to parse the file extension for a given file name.
		 */
		private getFileExtension (fileName: string): string {
			const parts = fileName.split(".")

			if (parts.length <= 1) {
				return ""
			} else {
				return parts[parts.length - 1].toLowerCase()
			}
		}

		/**
		 * @summary Handler for when the user drags an item over the dropzone. Ensures only files can be dropped.
		 */
		private onDragOver (event: DragEvent) {
			if (!event || !event.dataTransfer) {
				return
			}

			const dragItemInfo = event.dataTransfer.items[0]

			// If the user isn't dragging a file, or if the user isn't dragging an accepted image file type, reject the drag.
			if (dragItemInfo.kind !== "file" || !this.permittedFileTypes.includes(dragItemInfo.type)) {
				return
			}

			// Prevent the browser from blocking the drag event.
			event.preventDefault()
			this.dragging = true
		}

		/**
		 * @summary Handler for when the user drops an image, or selects one within the file dialog.
		 */
		private onImageSelected (event: Event | DragEvent): void {
			this.dragging = false

			// @ts-ignore
			const files = (event.target.files || event.dataTransfer.files) as File[]

			if (!files || !files.length) {
				return
			}

			const file = files[0]
			const extension = this.getFileExtension(file.name)

			if (!this.permittedFileExtensions.includes(extension)) {

			} else {
				event.preventDefault()
				this.$emit("input", file)
			}
		}
}
